module.exports = "<form class=\"form-vertical\" [formGroup]=\"form\">\n  <happy-text-input formControlName=\"domain\" [value]=\"form.controls.domain.value\">\n    <label input-label>Domain</label>\n    <span input-guidance>{{'onboarding.domain.guidance' | translate}}</span>\n    <div input-button-group-postfix class=\"input-group-btn\">\n      <button type=\"button\" disabled class=\"btn btn-default\">.itpx.one</button>\n    </div>\n  </happy-text-input>\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/dynamic-onboarding/domain/domain.component.html
// module id = ./src/app/core/components/dynamic-onboarding/domain/domain.component.html
// module chunks = main